import TrieSearch from "trie-search";

document.addEventListener("alpine:init", () => {
  Alpine.data(
    "postFormController",
    (post, blogBaseUrl, postURL, shareURL, tags) => ({
      url: postURL,
      post: {},
      tags: tags,
      timezoneVal: new Intl.DateTimeFormat().resolvedOptions().timeZone,
      timezoneOffsetVal: new Date().getTimezoneOffset() * 60,
      datePicker: null,
      overlayOpen: false,
      fileOverlayOpen: false,
      submitting: false,
      showCrossPostWarning: false,
      blogBaseUrl: blogBaseUrl,
      redirecting: false,

      showList: false,
      searcher: null,
      allTags: [],
      searchResults: [],
      selectedResult: -1,

      shouldShowCrossPostWarning() {
        this.showCrossPostWarning =
          this.post.is_published === false &&
          new Date(document.getElementById("publish_at").value) < Date.now();
      },

      init() {
        this.datePicker = window.setupFlatpickr("publish_at", {
          enableTime: true,
          dateFormat: "Y-m-d H:i:S",
          altInput: true,
          altFormat: "F J, Y  G:iK",
          disableMobile: true,
        });

        window.addEventListener(
          "beforeunload",
          function(e) {
            let allChangesSaved =
              this.redirecting ||
              this.$store.postContent.isEqualTo(this.post.content);

            // Only send a warning if we have unsaved changes
            if (!allChangesSaved) {
              e.preventDefault();
              e.returnValue = "";
            }
          }.bind(this),
        );

        this.setPostDetails(post);

        if (Array.isArray(tags) && tags.length > 0) {
          this.allTags = tags.map((tag) => ({
            ...tag,
            label: `${tag.name} (${tag.count})`,
          }));

          this.searcher = new TrieSearch();
          this.allTags.forEach((tag) => this.searcher.map(tag.name, tag));
        }
      },

      setPostDetails(newPost) {
        this.post = newPost;
        this.shouldShowCrossPostWarning();
        Array.from(document.getElementById("author").options).forEach((opt) => {
          if (this.post.author_id === opt.value) {
            this.post.author_name = opt.dataset.name;
          }
        });

        // if the post has a published_at date, set it to the datePicker
        if (this.post.published_at) {
          this.datePicker.setDate(new Date(newPost.published_at), true);
        }
      },

      insertPostFile(file) {
        if (this.overlayOpen) {
          // For featured image
          this.post.featured_image = { url: file.display_url };
          if (file.source == "swish") this.post.featured_image.id = file.id;
          return;
        }

        this.$dispatch("insert-file", file);
      },

      checkFeaturedImage(file) {
        if (this.post.featured_image.id == file.id) {
          this.removeFeaturedImage();
        }
      },

      removeFeaturedImage() {
        this.post.featured_image = { id: "", url: "" };
      },

      submit() {
        const $dispatch = this.$dispatch;

        if (this.submitting) return;
        this.submitting = true;

        let postForm = new FormData(document.getElementById("post-form"));
        postForm.append("content", this.$store.postContent.get());
        postForm.append("tags", this.post.tags.join(","));

        if (this.post.publish_at !== "") {
          postForm.append("publish_at", this.publishAt);
        }

        fetch(this.url, {
          credentials: "include",
          method: "POST",
          body: postForm,
        })
          .then(window.status)
          .then(window.json)
          .then(
            function(data) {
              if (data.redirect_to !== "") {
                this.redirecting = true;
                window.location = data.redirect_to;
                return;
              }

              data.success?.forEach(function(message) {
                $dispatch("notify", { msg: message, type: "success" });
              });
              data.error?.forEach(function(message) {
                $dispatch("notify", { msg: message, type: "error" });
              });

              this.setPostDetails(data.data);
              $dispatch("set-editor-value", data.data.content);
            }.bind(this),
          )
          .catch(function(err) {
            console.log("Fetch Error :-S", err);
            $dispatch("notify", { msg: "Error saving changes", type: "error" });
          })
          .finally(
            function() {
              this.submitting = false;
            }.bind(this),
          );
      },

      share(name, integration_id) {
        const $dispatch = this.$dispatch;

        const shareMsg = prompt(
          "Customize the share message.\nThe link to the post will be added at the end of the message.",
          this.post.title,
        );

        if (!confirm('Share to "' + name + '"?')) {
          $dispatch("notify", {
            msg: 'Canceled share to "' + name + '"',
            type: "error",
          });
          return;
        }

        let postForm = new FormData();
        postForm.append("post_id", this.post.id);
        postForm.append("share_message", shareMsg);

        fetch(shareURL.replaceAll("integration_id", integration_id), {
          credentials: "include",
          method: "POST",
          body: postForm,
        })
          .then(window.status)
          .then(window.json)
          .then(
            function(data) {
              data.success?.forEach(function(message) {
                $dispatch("notify", { msg: message, type: "success" });
              });
              data.error?.forEach(function(message) {
                $dispatch("notify", { msg: message, type: "error" });
              });
            }.bind(this),
          )
          .catch(function(err) {
            console.log("Fetch Error :-S", err);
            $dispatch("notify", { msg: "Error sharing post", type: "error" });
          })
          .finally(
            function() {
              this.submitting = false;
            }.bind(this),
          );
      },

      openOverlay() {
        document.getElementById("overlay").classList.remove("hidden");
        document.getElementById("overlay").classList.add("z-50");
        this.overlayOpen = true;
      },

      closeOverlay() {
        this.overlayOpen = false;
        this.datePicker.close();
        window.setTimeout(() => {
          document.getElementById("overlay").classList.add("hidden");
          document.getElementById("overlay").classList.remove("z-50");
        }, 700);
      },

      openFileOverlay() {
        document.getElementById("file-overlay").classList.remove("hidden");
        document.getElementById("file-overlay").classList.add("z-50");
        this.fileOverlayOpen = true;
      },

      closeFileOverlay() {
        this.fileOverlayOpen = false;
        window.setTimeout(() => {
          document.getElementById("file-overlay").classList.add("hidden");
          document.getElementById("file-overlay").classList.remove("z-50");
        }, 700);
      },

      deletePost() {
        if (this.submitting) return;

        const $dispatch = this.$dispatch;
        let c = confirm(
          `Are you sure you want to DELETE this ${this.post.type}?`,
        );
        if (!c) return;

        if (this.post.id === "") {
          $dispatch("notify", {
            msg: "cannot delete unsaved post",
            type: "error",
          });
          return;
        }

        this.submitting = true;

        fetch(this.post.id + "/delete", {
          credentials: "include",
          method: "GET",
        })
          .then(window.status)
          .then(window.json)
          .then(function(data) {
            data.success?.forEach(function(message) {
              $dispatch("notify", { msg: message, type: "success" });
            });
            data.error?.forEach(function(message) {
              $dispatch("notify", { msg: message, type: "error" });
            });
            if (data.redirect_to !== "") {
              window.location = data.redirect_to;
            }
          })
          .catch(function(err) {
            console.log("Fetch Error :-S", err);
            $dispatch("notify", { msg: "Error deleting post", type: "error" });
          })
          .finally(
            function() {
              this.submitting = false;
            }.bind(this),
          );
      },

      togglePublish() {
        if (this.post.is_published) {
          this.unpublish();
        } else {
          this.publish();
        }
      },

      publish() {
        let formValid = document.getElementById("post-form").reportValidity();

        let newPublishedDate = new Date();
        if (this.post.metadata.last_published) {
          newPublishedDate = new Date(this.post.metadata.last_published);
          // Make sure it is not a scheduled time
          let now = new Date();
          if (newPublishedDate - now > 0) {
            newPublishedDate = now;
          }
        }

        if (formValid) {
          this.datePicker.setDate(newPublishedDate);
          this.submit(this.$dispatch);
        }
      },

      unpublish() {
        this.datePicker.clear();
        this.submit(this.$dispatch);
      },

      tagging: {
        ["x-on:focus"]() {
          this.refreshResults();
          this.showList = true;
        },
        ["x-on:blur"](e) {
          this.showList = false;

          const related = e.relatedTarget;
          if (related && related.dataset.searchindex !== undefined) {
            this.resultSelected(
              related.dataset.searchindex,
              related.dataset.searchvalue,
            );
          }
        },
        ["x-on:input"]() {
          this.refreshResults();
        },
        ["x-on:keydown"](e) {
          // Add the current value on "comma"
          if (e.target.value === "" || e.which != 188) return;

          e.preventDefault();
          this.addToTags(e.target.value);
          return;
        },
        ["x-on:keydown.enter"](e) {
          if (e.target.value === "") return;

          e.preventDefault();

          if (this.selectedResult === -1) {
            this.addToTags(e.target.value);
            return;
          }

          const targetVal = this.searchResults[this.selectedResult].name;
          if (e.target.value === targetVal) {
            this.addToTags(targetVal);
            return;
          }

          e.target.value = targetVal;
        },
        ["x-on:keydown.tab"](e) {
          if (e.target.value === "") return;

          if (this.selectedResult === -1) {
            e.preventDefault();
            this.addToTags(e.target.value);
            return;
          }

          let targetVal = this.searchResults[this.selectedResult].name;
          if (e.target.value !== targetVal) {
            e.preventDefault();
            e.target.value = targetVal;
            return;
          }

          const maxIndex = this.searchResults.length - 1;
          if (maxIndex <= this.selectedResult) {
            e.target.value = "";
            this.refreshResults();
            return;
          }

          e.preventDefault();
          this.selectedResult++;
          targetVal = this.searchResults[this.selectedResult].name;
          e.target.value = targetVal;
        },
        ["x-on:keydown.up"]() {
          const minIndex = this.searchResults.length ? 0 : -1;

          if (minIndex < this.selectedResult) {
            this.selectedResult--;
          } else {
            this.selectedResult = minIndex;
          }
        },
        ["x-on:keydown.down"]() {
          const maxIndex = this.searchResults.length - 1;

          if (maxIndex > this.selectedResult) {
            this.selectedResult++;
          } else {
            this.selectedResult = maxIndex;
          }
        },
      },

      refreshResults() {
        let results = this.searcher.search(this.$refs.tagInput.value);
        if (results.length === 0) {
          results = this.allTags;
        }
        this.searchResults = results;
        this.selectedResult = results.length ? 0 : -1;
      },

      resultSelected(index, _text) {
        const tagName = this.searchResults[index].name;
        this.addToTags(tagName);
      },

      addToTags(text) {
        if (!text) return;

        this.post.tags.push(...text.split(",").map((e) => e.trim()));

        // clear the field
        this.$refs.tagInput.value = "";
        this.$refs.tagInput.focus();
        this.refreshResults();
      },
    }),
  );
});
